import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import { getUrl } from "../../utils/helper";

class Filter extends Component {
    render() {
        const { data, current } = this.props;

        return (
            <div className="flex xl:justify-center overflow-x-auto">
                {data.map((item, index) => (
                    <div key={index} className="mx-16 xl:mx-20">
                        <Link
                            to={
                                item.slug
                                    ? getUrl("bookmarks/" + item.slug)
                                    : getUrl("bookmarks")
                            }
                            style={{ color: item.color }}
                            className={
                                "font-judge font-bold text-20 xl:text-30 uppercase"
                            }
                            title={item.name}
                        >
                            {item.name}
                        </Link>
                        <div
                            style={{
                                backgroundColor:
                                    current === item.slug
                                        ? item.color
                                        : "transparent",
                            }}
                            className={"h-2 xl:h-4 w-full"}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
